import React, { useEffect, useState } from 'react'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { shuffleArray } from 'src/utils/shuffleArray'

export function LoadingMessages() {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  // Translated on every render, never captured once: this screen shows while the
  // player's translation catalogue is still loading, so text taken from the first
  // render is the English key and would stay English for the whole load.
  const messages = [
    t('Connecting to the action...'),
    t('Setting up your view...'),
    t('Firing up the stream...'),
    t('Almost showtime...'),
    t('Tuning in...'),
    t('Getting everything ready...')
  ]

  // Shuffle the display ORDER once, not the translated strings.
  const [order] = useState(() => shuffleArray(messages.map((_, i) => i)))
  const [position, setPosition] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setPosition((current) => (current + 1) % order.length)
    }, 2000)

    return () => {
      clearInterval(interval)
    }
  }, [order.length])

  return <span className="loading-message">{messages[order[position] ?? 0] ?? ''}</span>
}
